import authFetch from './fetch';
import qs from 'qs';
import { getQueryParams, makeRequest } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

export const routes = {
  warehousesPath: () => 'api/CMSv2/warehouses',
  warehousesGridPath: () => '/api/CMSv2/Warehouses/Grid',
  warehousesSearchPropertiesPath: () => '/api/CMSv2/Warehouses/SearchProperties',
  restoreWarehousePath: (id) => `/api/CMSv2/Warehouses/${id}/Restore`,
  warehousesLookupsPath: () => 'api/CMSv2/warehouses/lookups',
  warehouseListPath: () => 'api/Warehouses/groups',
  CCCCommoditiesPath: () => '/api/CMSv2/Warehouses/CCCCommodities',
  CCCCommoditiesGridPath: () => '/api/CMSv2/Warehouses/CCCCommodities/Grid',
  CCCCommoditiesAuditPath: (id, params) => `/api/CMSv2/Warehouses/CCCCommodities/${id}/Audits${getQueryParams(params)}`,
  CCCCommoditiesAuditUsersPath: (id) => `/api/CMSv2/Warehouses/CCCCommodities/${id}/Audits/Users`,
  CCCCommoditiesAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/CCCCommodities/${id}/Audits/Properties`,
  CCCCommoditiesSearchPropertiesPath: () => '/api/CMSv2/Warehouses/CCCCommodities/SearchProperties',
  restoreCCCCommodityPath: (id) => `/api/CMSv2/Warehouses/CCCCommodities/${id}/Restore`,
  warehousesAuditPath: (id, params) => `/api/CMSv2/Warehouses/${id}/Audits${getQueryParams(params)}`,
  warehousesAuditUsersPath: (id) => `/api/CMSv2/Warehouses/${id}/Audits/Users`,
  warehousesAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/${id}/Audits/Properties`,
  CCCStandardAuditPath: (id, params) => `/api/CMSv2/Warehouses/CCCStandards/${id}/Audits${getQueryParams(params)}`,
  CCCStandardAuditUsersPath: (id) => `/api/CMSv2/Warehouses/CCCStandards/${id}/Audits/Users`,
  CCCStandardAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/CCCStandards/${id}/Audits/Properties`,
  CCCStandardPath: (id) => `/api/CMSv2/Warehouses/CCCStandards/${id}`,
  CCCStandardsPath: () => '/api/CMSv2/Warehouses/CCCStandards',
  CCCStandardsGridPath: () => '/api/CMSv2/Warehouses/CCCStandards/Grid',
  CCCStandardsShortInfosPath: () => '/api/CMSv2/Warehouses/CCCStandards/Lookups',
  CCCStandardsSearchPropertiesPath: () => '/api/CMSv2/Warehouses/CCCStandards/SearchProperties',
  restoreCCCStandardPath: (id) => `/api/CMSv2/Warehouses/CCCStandards/${id}/Restore`,
  CCCCommodityByIdPath: (id) => `/api/CMSv2/Warehouses/CCCCommodities/${id}`,
  equipmentTypesPath: (category) => (category ? `/api/EquipmentType/Lookup?category=${category}` : '/api/EquipmentType/Lookup'),
  allEquipmentTypesPath: (category) => (category ? `/api/EquipmentType?category=${category}` : '/api/EquipmentType'),
  activityTypesPath: () => '/api/CMSv2/Warehouses/ActivityTypes',
  campusesTypesPath: () => '/api/CMSv2/Warehouses/Campuses',
  unitOfMeasurePath: () => '/api/CMSv2/Warehouses/UnitsOfMeasure',
  unitsOfMeasureGridPath: (params) => `/api/CMSv2/Warehouses/UnitsOfMeasure/Grid${getQueryParams(params)}`,
  unitOfMeasureByIdPath: (id) => `/api/CMSv2/Warehouses/UnitsOfMeasure/${id}`,
  unitOfMeasureSearchPropertiesPath: () => '/api/CMSv2/Warehouses/UnitsOfMeasure/SearchProperties',
  unitsOfMeasureAuditPathById: (id, params) => `/api/CMSv2/Warehouses/UnitsOfMeasure/${id}/Audits${getQueryParams(params)}`,
  unitsOfMeasureAuditUsersPathById: (id) => `/api/CMSv2/Warehouses/UnitsOfMeasure/${id}/Audits/Users`,
  unitsOfMeasureAuditPropertiesPathById: (id) => `/api/CMSv2/Warehouses/UnitsOfMeasure/${id}/Audits/Properties`,
  restoreUnitOfMeasurePath: (id) => `/api/CMSv2/Warehouses/UnitsOfMeasure/${id}/Restore`,
  productByIdPath: (id) => `/api/CMSv2/Warehouses/Products/${id}`,
  restoreProductByIdPath: (id) => `/api/CMSv2/Warehouses/Products/${id}/Restore`,
  productsPath: (params) => `/api/CMSv2/Warehouses/Products${getQueryParams(params)}`,
  schedulesPath: () => '/api/CMSv2/Warehouses/Schedules',
  schedulesGridPath: () => '/api/CMSv2/Warehouses/Schedules/Grid',
  schedulesSearchPropertiesPath: () => '/api/CMSv2/Warehouses/Schedules/SearchProperties',
  restoreSchedulePath: (id) => `/api/CMSv2/Warehouses/Schedules/${id}/Restore`,
  schedulesPathLookups: () => '/api/CMSv2/Warehouses/SchedulesLookups',
  scheduleByIdPath: (id) => `/api/CMSv2/Warehouses/Schedules/${id}`,
  bayLocationsPath: () => '/api/CMSv2/Warehouses/BayLocations',
  bayLocationsGridPath: () => '/api/CMSv2/Warehouses/BayLocations/Grid',
  bayLocationByIdPath: (id) => `/api/CMSv2/Warehouses/BayLocations/${id}`,
  bayLocationRestorePath: (id) => `/api/CMSv2/Warehouses/BayLocations/${id}/restore`,
  bayLocationSearchPropertiesPath: () => '/api/CMSv2/Warehouses/BayLocations/SearchProperties',
  bayLocationsAuditPath: (id, params) => `/api/CMSv2/Warehouses/BayLocations/${id}/Audits${getQueryParams(params)}`,
  bayLocationsAuditUsersPath: (id) => `/api/CMSv2/Warehouses/BayLocations/${id}/Audits/Users`,
  bayLocationsAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/BayLocations/${id}/Audits/Properties`,
  CCCTerminalTypesPath: () => '/api/CMSv2/Warehouses/CCCTerminalTypes',
  exportHoldReasonsPath: () => '/api/CMSv2/Warehouses/ExportHoldReasons',
  importHoldReasonsPath: () => '/api/CMSv2/Warehouses/ImportHoldReasons',
  accountTypesPath: () => '/api/CMSv2/Warehouses/AccountTypes',
  receivingTypesPath: () => '/api/CMSv2/Warehouses/ReceivingTypes',
  outboundModesPath: () => '/api/CMSv2/Warehouses/OutboundModes',
  scheduleAuditPathById: (id, params) => `/api/CMSv2/Warehouses/Schedules/${id}/Audits${getQueryParams(params)}`,
  scheduleAuditUsersPathById: (id) => `/api/CMSv2/Warehouses/Schedules/${id}/Audits/Users`,
  scheduleAuditPropertiesPathById: (id) => `/api/CMSv2/Warehouses/Schedules/${id}/Audits/Properties`,
  handlingTypesPath: () => '/api/CMSv2/Warehouses/HandlingTypes',
  handlingTypesForEquipmentSizesPath: () => '/api/CMSv2/Warehouses/HandlingTypesForEquipmentSizes',
  equipmentSizesPath: () => '/api/CMSv2/Warehouses/EquipmentSizes',
  additionalChargesPath: (params) => `/api/CMSv2/Warehouses/AdditionalCharges${getQueryParams(params)}`,
  additionalChargePath: (id) => `/api/CMSv2/Warehouses/AdditionalCharges/${id}`,
  additionalChargeAuditPath: (id, params) => `/api/CMSv2/Warehouses/AdditionalCharges/${id}/Audits${getQueryParams(params)}`,
  additionalChargeAuditUsersPath: (id) => `/api/CMSv2/Warehouses/AdditionalCharges/${id}/Audits/Users`,
  additionalChargeAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/AdditionalCharges/${id}/Audits/Properties`,
  restoreAdditionalChargePath: (id) => `/api/CMSv2/Warehouses/AdditionalCharges/${id}/Restore`,
  quoteHandlingChargesPath: () => '/api/CMSv2/Warehouses/QuoteHandlingCharges',
  warehouseAppointmentsSlotsPath: (warehouseId) => `/api/CMSv2/Warehouses/WarehouseAppointmentsSlots/${warehouseId}`,
  updateWarehouseAppointmentsSlotsPath: () => '/api/CMSv2/Warehouses/WarehouseAppointmentsSlots/bulkUpdate',
  getOrderWarehouseAppointmentSlotLookupPath: (proNumber) => `api/Orders/${proNumber}/WarehouseAppointmentSlotLookup`,
  unitTypesPath: () => '/api/CMSv2/Warehouses/UnitTypes',
  handlingStandardsPath: (params) => `/api/CMSv2/Warehouses/HandlingStandards${getQueryParams(params)}`,
  handlingStandardPath: (id) => `/api/CMSv2/Warehouses/HandlingStandards/${id}`,
  handlingStandardAuditsPath: (id, params) => `/api/CMSv2/Warehouses/HandlingStandards/${id}/Audits${getQueryParams(params)}`,
  handlingStandardAuditsUsersPath: (id) => `/api/CMSv2/Warehouses/HandlingStandards/${id}/Audits/Users`,
  handlingStandardAuditsPropertiesPath: (id) => `/api/CMSv2/Warehouses/HandlingStandards/${id}/Audits/Properties`,
  handlingStandardRestorePath: (id) => `/api/CMSv2/Warehouses/HandlingStandards/${id}/Restore`,
  costsPath: () => '/api/CMSv2/Warehouses/Costs',
  costPath: (id) => `/api/CMSv2/Warehouses/Costs/${id}`,
  restoreCostPath: (id) => `/api/CMSv2/Warehouses/Costs/${id}/Restore`,
  costTypesPath: () => '/api/CMSv2/Warehouses/CostTypes',
  costsAuditPath: (id, params) => `/api/CMSv2/Warehouses/Costs/${id}/Audits${getQueryParams(params)}`,
  orderAndDraftCheckInByProNumberPath: (proNumber) => `/api/CMSv2/WarehouseOrderCheckIn/orderAndDraftCheckInByProNumber/${proNumber}`,
  checkInEquipmentTypePath: () => '/api/CMSv2/WarehouseOrderCheckIn/checkInEquipmentType',
  availableSlotsPath: (query) => `/api/CMSv2/WarehouseOrderCheckIn/availableSlots?${qs.stringify(query)}`,
  warehouseCheckInPath: () => '/api/CMSv2/WarehouseOrderCheckIn',
  checkInExistsPath: (proNumber, warehouseId) => `/api/CMSv2/WarehouseOrderCheckIn/checkInExists?proNumber=${proNumber}&warehouseId=${warehouseId}`,
  ordersV2Path: () => '/whseApp/Orders/v2',
  loadDetailsV2Path: (proNumber) => `/whseApp/Orders/v2/${proNumber}`,
  updateDetailsV2Path: () => '/whseApp/Orders/v2/',
  onHandReportPath: (filter) => `/api/CMSv2/Reports/onHand?${qs.stringify(filter)}`,
  averageInventoryReportPath: (filter) => `/api/CMSv2/Reports/averageInventory?${qs.stringify(filter)}`,
  productStatusReportPath: () => '/api/CMSv2/Reports/ProductStatus',
  productStatusReportExcelPath: (filter) => `/api/CMSv2/Reports/ProductStatus/Excel?${qs.stringify(filter)}`,
  productStatusReportFilterFieldsPath: () => '/api/CMSv2/Reports/ProductStatus/FilterFields',
  exportOnHandReportToExcelPath: (filter) => `/api/CMSv2/Reports/onHand/excel?${qs.stringify(filter)}`,
  costsAuditUsersPath: (id) => `/api/CMSv2/Warehouses/Costs/${id}/Audits/Users`,
  costsAuditPropertiesPath: (id) => `/api/CMSv2/Warehouses/Costs/${id}/Audits/Properties`,
};

export const getProductsPaginated = (params) => makeRequest(authFetch.get(routes.productsPath(params)));
export const fetchWarehouses = () => authFetch.get(routes.warehousesPath());
export const getWarehousesGrid = (params) => makeRequest(authFetch.get(`${routes.warehousesGridPath()}${getQueryParams(params)}`));

export const restoreWarehouse = (id) => makeRequest(authFetch.patch(routes.restoreWarehousePath(id)));

export const getWarehousesSearchProperties = () => makeRequest(authFetch.get(routes.warehousesSearchPropertiesPath()));

export const fetchWarehouseList = () => authFetch.get(routes.warehouseListPath());

export const getWarehouse = async (id) => makeRequest(authFetch.get(`${routes.warehousesPath()}/${id}`));

export const getWarehousesLookups = () => authFetch
  .get(routes.warehousesLookupsPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const upsertWarehouse = (warehouse, options) => authFetch
  .put(routes.warehousesPath(), warehouse, options)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const deleteWarehouse = (id) => authFetch
  .delete(`${routes.warehousesPath()}/${id}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getOrders = async () => {
  try {
    const response = await authFetch.get('/whseApp/Orders');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrdersV2 = async () => await makeRequest(authFetch.get(routes.ordersV2Path()));
export const loadDetailsV2 = async (proNumber) => await makeRequest(authFetch.get(routes.loadDetailsV2Path(proNumber)));
export const updateDetailsV2 = async (loadDetails) => await makeRequest(authFetch.put(routes.updateDetailsV2Path(), loadDetails));

export const getOrder = async (proNumber) => {
  try {
    const response = await authFetch.get(`/whseApp/Orders/${proNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getPLOrder = async (proNumber) => {
  try {
    const response = await authFetch.get(`/whseApp/PickListOrders/${proNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateOrder = async (proNumber, data) => {
  try {
    const response = await authFetch.put(`/whseApp/Orders/${proNumber}`, data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updatePLOrder = async (proNumber, data) => {
  try {
    const response = await authFetch.put(`/whseApp/PickListOrders/${proNumber}`, data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBayLocations = async (warehouse) => {
  try {
    const response = await authFetch.get(`/whseApp/Warehouses/baylocations?Warehouse=${warehouse}&PerPage=999999`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const validateEquipmentNumber = async (proNumber, equipmentNumber) => {
  try {
    const response = await authFetch.get(`/whseApp/orders/${proNumber}/isvalidequipment/${equipmentNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const requestHelp = async (proNumber, warehouse, assistanceType = 'ForkLiftOperator') => {
  try {
    const response = await authFetch.post(`/whseApp/Orders/${proNumber}/assistance`, { warehouse, assistanceType });
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const assignHelp = async (proNumber, id) => {
  try {
    const response = await authFetch.put(`/whseApp/Orders/${proNumber}/assistance/${id}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const completeHelp = async (proNumber, id) => {
  try {
    const response = await authFetch.delete(`/whseApp/Orders/${proNumber}/assistance/${id}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const startOrder = async (proNumber, type) => {
  try {
    const response = await authFetch.post(`/whseApp/Orders/${proNumber}/start/${type}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getPrinters = async () => {
  try {
    const response = await authFetch.get('/whseApp/orders/printers');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const printLabels = async (printData) => {
  try {
    const response = await authFetch.post('/whseApp/orders/printLabels', printData);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getProducts = async () => {
  try {
    const response = await authFetch.get('/api/CMSv2/Warehouses/Products');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getProductsLookups = async () => {
  try {
    const response = await authFetch.get('/api/CMSv2/Warehouses/Products/Lookups');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getProduct = (id) => authFetch
  .get(routes.productByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const deleteProduct = (id) => authFetch
  .delete(routes.productByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const restoreProduct = (id) => authFetch
  .patch(routes.restoreProductByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const postProduct = async (product) => {
  try {
    const response = await authFetch.put('/api/CMSv2/Warehouses/Products', product);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getUnitsOfMeasure = () => makeRequest(authFetch.get('/api/CMSv2/Warehouses/UnitsOfMeasure'));
export const useGetUnitsOfMeasure = () => useQuery(['unitsOfMeasure'], getUnitsOfMeasure, CacheConfig.forever);

export const getUnitsOfMeasureSearchProperties = () => makeRequest(authFetch.get(routes.unitOfMeasureSearchPropertiesPath()));
export const restoreUnitOfMeasure = (id) => makeRequest(authFetch.patch(routes.restoreUnitOfMeasurePath(id)));
export const getUnitsOfMeasureGrid = (params) => makeRequest(authFetch.get(routes.unitsOfMeasureGridPath(params)));
export const getUnitsOfMeasureAudits = async (id, params) => makeRequest(authFetch.get(routes.unitsOfMeasureAuditPathById(id, params)));
export const getUnitsOfMeasureAuditUsers = async (id) => makeRequest(authFetch.get(routes.unitsOfMeasureAuditUsersPathById(id)));
export const getUnitsOfMeasureAuditProperties = async (id) => makeRequest(authFetch.get(routes.unitsOfMeasureAuditPropertiesPathById(id)));

export const postUnitOfMeasure = async (unitOfMeasure) => {
  try {
    const response = await authFetch.put('/api/CMSv2/Warehouses/UnitsOfMeasure', unitOfMeasure);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteUnitOfMeasure = async (id) => authFetch
  .delete(routes.unitOfMeasureByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCCommodities = () => authFetch
  .get(routes.CCCCommoditiesPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCCommoditiesGrid = (params) => makeRequest(authFetch.get(`${routes.CCCCommoditiesGridPath()}${getQueryParams(params)}`));
export const restoreCCCCommodity = (id) => makeRequest(authFetch.patch(routes.restoreCCCCommodityPath(id)));
export const getCCCCommoditiesSearchProperties = () => makeRequest(authFetch.get(routes.CCCCommoditiesSearchPropertiesPath()));

export const getCCCCommodityById = (id) => authFetch
  .get(`${routes.CCCCommodityByIdPath(id)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const upsertCCCCommodity = (ccc, options) => authFetch
  .put(routes.CCCCommoditiesPath(), ccc, options)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCCommodityAudits = (id, params) => authFetch
  .get(`${routes.CCCCommoditiesAuditPath(id, params)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCCommodityAuditUsers = (id) => authFetch
  .get(`${routes.CCCCommoditiesAuditUsersPath(id)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCCommodityAuditProperties = (id) => authFetch
  .get(`${routes.CCCCommoditiesAuditPropertiesPath(id)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCStandards = () => authFetch
  .get(routes.CCCStandardsPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCStandardById = (id) => makeRequest(authFetch.get(routes.CCCStandardPath(id)));
export const getCCCStandardsGrid = async (params) => makeRequest(authFetch.get(`${routes.CCCStandardsGridPath()}${getQueryParams(params)}`));
export const restoreCCCStandard = (id) => makeRequest(authFetch.patch(routes.restoreCCCStandardPath(id)));
export const getCCCStandardSearchProperties = async (params) => makeRequest(authFetch.get(`${routes.CCCStandardsSearchPropertiesPath()}${getQueryParams(params)}`));

export const getCCCStandardsShortInfos = () => authFetch
  .get(routes.CCCStandardsShortInfosPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCStandardAudits = (id, params) => authFetch
  .get(`${routes.CCCStandardAuditPath(id, params)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCStandardAuditUsers = (id) => authFetch
  .get(`${routes.CCCStandardAuditUsersPath(id)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCStandardAuditProperties = (id) => authFetch
  .get(`${routes.CCCStandardAuditPropertiesPath(id)}`)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const upsertCCCStandard = (standard, options) => authFetch
  .put(routes.CCCStandardsPath(), standard, options)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getEquipmentTypes = async (category) => makeRequest(authFetch.get(`${routes.equipmentTypesPath(category)}`));
export const getAllEquipmentTypes = async (category) => makeRequest(authFetch.get(`${routes.allEquipmentTypesPath(category)}`));

export const getActivityTypes = () => authFetch
  .get(routes.activityTypesPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCampuses = () => makeRequest(authFetch.get(routes.campusesTypesPath()));
export const getV2BayLocations = () => makeRequest(authFetch.get(routes.bayLocationsPath()));
export const getV2BayLocationsGrid = async (params) => makeRequest(authFetch.get(`${routes.bayLocationsGridPath()}${getQueryParams(params)}`));
export const restoreBayLocation = (id) => makeRequest(authFetch.patch(routes.bayLocationRestorePath(id)));
export const getBayLocationsSearchProperties = () => makeRequest(authFetch.get(routes.bayLocationSearchPropertiesPath()));

export const deleteBayLocation = (id) => authFetch
  .delete(routes.bayLocationByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getBayLocation = (id) => authFetch
  .get(routes.bayLocationByIdPath(id))
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const upsertBayLocation = (bayLocation) => authFetch
  .put(routes.bayLocationsPath(), bayLocation)
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getCCCTerminalTypes = () => authFetch
  .get(routes.CCCTerminalTypesPath())
  .then(({ data }) => data)
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const getExportHoldReasons = () => makeRequest(authFetch.get(routes.exportHoldReasonsPath()));
export const getImportHoldReasons = () => makeRequest(authFetch.get(routes.importHoldReasonsPath()));
export const getAccountTypes = () => makeRequest(authFetch.get(routes.accountTypesPath()));
export const getReceivingTypes = () => makeRequest(authFetch.get(routes.receivingTypesPath()));
export const getOutboundModes = () => makeRequest(authFetch.get(routes.outboundModesPath()));
export const getSchedules = async (params) => makeRequest(authFetch.get(`${routes.schedulesPath()}${getQueryParams(params)}`));
export const getSchedulesGrid = async (params) => makeRequest(authFetch.get(`${routes.schedulesGridPath()}${getQueryParams(params)}`));
export const getSchedulesSearchProperties = () => makeRequest(authFetch.get(routes.schedulesSearchPropertiesPath()));
export const restoreSchedule = (id) => makeRequest(authFetch.patch(routes.restoreSchedulePath(id)));
export const getSchedulesLookups = () => makeRequest(authFetch.get(routes.schedulesPathLookups()));
export const getSchedule = async (id) => makeRequest(authFetch.get(routes.scheduleByIdPath(id)));
export const getScheduleAudits = async (id, params) => makeRequest(authFetch.get(routes.scheduleAuditPathById(id, params)));
export const getScheduleAuditUsers = async (id) => makeRequest(authFetch.get(routes.scheduleAuditUsersPathById(id)));
export const getScheduleAuditProperties = async (id) => makeRequest(authFetch.get(routes.scheduleAuditPropertiesPathById(id)));
export const getHandlingTypes = () => makeRequest(authFetch.get(routes.handlingTypesPath()));
export const upsertSchedule = async (schedule, options) => makeRequest(authFetch.put(routes.schedulesPath(), schedule, options));
export const getHandlingTypesForEquipmentSizes = async (params) => makeRequest(authFetch.get(`${routes.handlingTypesForEquipmentSizesPath()}?${getQueryParams(params, { indices: false })}`));
export const getEquipmentSizes = () => makeRequest(authFetch.get(routes.equipmentSizesPath()));
export const getAdditionalCharges = (params) => makeRequest(authFetch.get(routes.additionalChargesPath(params)));
export const getAdditionalCharge = (id) => makeRequest(authFetch.get(routes.additionalChargePath(id)));
export const getAdditionalChargeAudits = (id, params) => makeRequest(authFetch.get(routes.additionalChargeAuditPath(id, params)));
export const getAdditionalChargeAuditUsers = (id) => makeRequest(authFetch.get(routes.additionalChargeAuditUsersPath(id)));
export const getAdditionalChargeAuditProperties = (id) => makeRequest(authFetch.get(routes.additionalChargeAuditPropertiesPath(id)));
export const deleteAdditionalCharge = (id) => makeRequest(authFetch.delete(routes.additionalChargePath(id)));
export const getQuoteHandlingCharges = async (params) => makeRequest(authFetch.get(`${routes.quoteHandlingChargesPath()}${getQueryParams(params)}`));
export const getWarehouseAppointmentsSlots = (warehouseScheduleId) => makeRequest(
  authFetch.get(routes.warehouseAppointmentsSlotsPath(warehouseScheduleId)).then((response) => {
    const data = {
      ...response.data,
      date: response.data.date ? new Date(response.data.date) : new Date(),
    };
    return { data };
  }),
);

export const updateWarehouseAppointmentsSlots = (slots) => makeRequest(authFetch.put(routes.updateWarehouseAppointmentsSlotsPath(), slots));
export const getOrderWarehouseAppointmentSlotLookup = (proNumber) => makeRequest(authFetch.get(routes.getOrderWarehouseAppointmentSlotLookupPath(proNumber)));
export const getUnitTypes = () => makeRequest(authFetch.get(routes.unitTypesPath()));
export const upsertAddtionalCharge = async (charge) => makeRequest(authFetch.put(routes.additionalChargesPath(), charge));
export const restoreAddtionalCharge = async (id) => makeRequest(authFetch.patch(routes.restoreAdditionalChargePath(id)));
export const getHandlingStandards = (params) => makeRequest(authFetch.get(routes.handlingStandardsPath(params)));
export const upsertHandlingStandard = async (standard) => makeRequest(authFetch.put(routes.handlingStandardsPath(), standard));
export const deleteHandlingStandard = async (id) => makeRequest(authFetch.delete(routes.handlingStandardPath(id)));
export const getHandlingStandard = async (id) => makeRequest(authFetch.get(routes.handlingStandardPath(id)));
export const getHandlingStandardAudits = async (id, params) => makeRequest(authFetch.get(routes.handlingStandardAuditsPath(id, params)));
export const getHandlingStandardAuditsUsers = async (id) => makeRequest(authFetch.get(routes.handlingStandardAuditsUsersPath(id)));
export const getHandlingStandardAuditsProperties = async (id) => makeRequest(authFetch.get(routes.handlingStandardAuditsPropertiesPath(id)));
export const restoreHandlingStandard = async (id) => makeRequest(authFetch.patch(routes.handlingStandardRestorePath(id)));
export const getCosts = (params) => makeRequest(authFetch.get(`${routes.costsPath()}${getQueryParams(params)}`));
export const getCost = (id) => makeRequest(authFetch.get(routes.costPath(id)));
export const getCostTypes = () => makeRequest(authFetch.get(routes.costTypesPath()));
export const upsertWarehouseCost = (cost, options) => makeRequest(authFetch.put(routes.costsPath(), cost, options));
export const restoreWarehouseCost = (id) => makeRequest(authFetch.patch(routes.restoreCostPath(id)));
export const getCostsAudit = (id, params) => makeRequest(authFetch.get(routes.costsAuditPath(id, params)));
export const getOrderAndDraftCheckInByProNumber = async (proNumber) => makeRequest(authFetch.get(routes.orderAndDraftCheckInByProNumberPath(proNumber)));
export const getCheckInEquipmentTypes = () => makeRequest(authFetch.get(routes.checkInEquipmentTypePath()));
export const getAvailableSlots = (query) => makeRequest(authFetch.get(routes.availableSlotsPath(query)));
export const postWarehouseCheckIn = (checkIn) => makeRequest(authFetch.put(routes.warehouseCheckInPath(), checkIn));
export const checkInExists = (proNumber, warehouseId) => makeRequest(authFetch.get(routes.checkInExistsPath(proNumber, warehouseId)));
export const getOnHandReport = (filter) => makeRequest(authFetch.get(routes.onHandReportPath(filter)));
export const getAverageInventoryReport = (filter) => makeRequest(authFetch.get(routes.averageInventoryReportPath(filter)));
export const getProductStatusReport = (filter) => makeRequest(authFetch.post(routes.productStatusReportPath(), filter));
export const getProductStatusExcelReport = (filter) => makeRequest(authFetch.get(routes.productStatusReportExcelPath(filter)));
export const getProductStatusReportFilterFields = () => makeRequest(authFetch.get(routes.productStatusReportFilterFieldsPath()));
export const exportOnHandReportToExcel = (filter) => makeRequest(authFetch.get(routes.exportOnHandReportToExcelPath(filter)));

export const getCostsAuditUsers = (id) => makeRequest(authFetch.get(routes.costsAuditUsersPath(id)));
export const getCostsAuditProperties = (id) => makeRequest(authFetch.get(routes.costsAuditPropertiesPath(id)));

export const getWarehousesAudits = async (id, params) => makeRequest(authFetch.get(routes.warehousesAuditPath(id, params)));
export const getWarehousesAuditUsers = (id) => makeRequest(authFetch.get(routes.warehousesAuditUsersPath(id)));
export const getWarehousesAuditProperties = (id) => makeRequest(authFetch.get(routes.warehousesAuditPropertiesPath(id)));

export const getBayLocationsAudits = async (id, params) => makeRequest(authFetch.get(routes.bayLocationsAuditPath(id, params)));
export const getBayLocationsAuditUsers = (id) => makeRequest(authFetch.get(routes.bayLocationsAuditUsersPath(id)));
export const getBayLocationsAuditProperties = (id) => makeRequest(authFetch.get(routes.bayLocationsAuditPropertiesPath(id)));

export const getFieldsToTrack = () => makeRequest(authFetch.get('/api/CMSv2/Warehouses/Products/FieldsToTrack'));
export const useGetFieldsToTrack = () => useQuery(['fieldsToTrack'], getFieldsToTrack, CacheConfig.forever);
